import type { AvailabilityDistributionOperation } from '@/shared/api';

/**
 * Was ein Fehlercode einer Übertragung heißt (`AvailabilityDistributionCalendarService.ToOperation`).
 * Derselbe Code steht bei „Wird wiederholt“ und „Fehlgeschlagen“ – der Satz richtet sich nach dem
 * Zustand. Ein neuer Code hat noch keinen Satz und bleibt als Rohcode sichtbar.
 */
export function ariErrorSentence(operation: AvailabilityDistributionOperation): string | null {
  if (operation.errorCode === 'ari_operation_suppressed') {
    return 'Grund: Der Workspace ist deaktiviert, oder das Apartment ist archiviert oder nicht bei Channex veröffentlicht.';
  }
  if (operation.errorCode === 'ari_operation_failed') {
    // Aufgegeben wird auch beim ersten Versuch (Ablehnung durch Channex) oder nach Aufschub ohne
    // Versuch; ob Channex den Stand hat, ist dann offen – bestätigt hat es ihn nicht.
    return operation.status === 'Failed'
      ? 'Aufgegeben – Channex hat diesen Stand nicht bestätigt.'
      : 'Noch nicht übertragen; der nächste Versuch folgt automatisch.';
  }
  return null;
}

/** Der Satz zum Zustand der Übertragung, vor dem Satz zum Code. */
export function ariStatusSentence(operation: AvailabilityDistributionOperation): string {
  if (operation.status === 'Confirmed')
    return 'Der Channex-Rückvergleich hat die Übertragung bestätigt.';
  if (operation.status === 'SentUnverified')
    return 'An Channex übertragen; ein zusätzlicher Rückvergleich wurde nicht angefordert.';
  if (operation.status === 'Suppressed') return 'Die Änderung wurde nicht an Channex gesendet.';
  if (operation.status === 'Failed') return 'Die Übertragung konnte nicht abgeschlossen werden.';
  return 'Die Änderung wird sicher im Hintergrund übertragen.';
}
